"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LIST_ICON_WRAPPER = void 0;
const LIST_ICON_WRAPPER = exports.LIST_ICON_WRAPPER = 'list-icon-wrapper';
